// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

//Backend access
import PropTypes from "prop-types";

// Images
import TranslinkPlinth from "assets/images/overlays/qld_plinth_thumb.png";
import TranslinkPole from "assets/images/overlays/eStop-dual-QLD.png";
import TranslinkKerbside from "assets/images/overlays/qld_kerbside.png";
import TranslinkCPT from "assets/images/overlays/CP-template-r1.png";
import TranslinkCPF from "assets/images/overlays/CP-Ferry_template-r1.png";
import TranslinkSMBI from "assets/images/overlays/SMBI-template_r1.png";
import TfnswNSD from "assets/images/overlays/TFNSW-CMS-template-5.png";
import TranslinkStationlink from "assets/images/overlays/TRANSLINK-UrbanDual-CMS-icon2.png";
import YarraTramsSingle from "assets/images/overlays/eStop-single-Yarra.png";
import YarraTramsDouble from "assets/images/overlays/eStop-dual-Yarra.png";
import PhiladelphiaParking from "assets/images/overlays/eMinor-Philly-CMS-template1.png";
import BombahPointFerry16km from "assets/images/overlays/BF-thumb-16km.png";
import BombahPointFerry20km from "assets/images/overlays/BF-thumb-20km.png";
import TransperthSingle from "assets/images/overlays/transperth-thumb-single.png";
import TransperthDouble from "assets/images/overlays/transperth-thumb-double.png";
import Dunedin from "assets/images/overlays/dunedin-thumb.png";
import ClearwaysSEC from "assets/images/overlays/eMinor-TfNSW-CMS-template.png";
import MBTABus from "assets/images/overlays/eStop-dual-MBTA-bus.png";
import MBTATram from "assets/images/overlays/eStop-dual-MBTA-tram.png";
import PTVDouble from "assets/images/overlays/eStop-dual-PTV.png";
import PTVSingle from "assets/images/overlays/eStop-single-PTV.png";

import DreamworldMMR from "assets/images/overlays/dreamworld/Dreamworld_MMR.png";

import SOPATreillage from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Treillage.png";
import SOPAArcOfPines from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Arc-of-Pines.png";
import SOPABanquet from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Banquet.png";
import SOPAEducation from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Education.png";
import SOPAEgret from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Egret.png";
import SOPAHeron from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Heron.png";
import SOPAHill from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Hill-Pavilion.png";
import SOPALakeside from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Lakeside.png";
import SOPATreeFrog from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Tree-Frog.png";
import SOPATwinShade from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Twin-Shade.png";
import SOPABellFrog from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Bell-frog.png";
import SOPACorymbia from "assets/images/overlays/sopa/eMinor-SOPA-CMS-template_Corymbia.png";

import CombinedPerspectiveCanvas from "../perspective";

function setupLiveviewOverlay(device) {
    if (!device.overlay_id) {
        return null;
    }

    switch (device.overlay_id) {
        case 'translink-plinth':
            return TranslinkPlinth;
        case 'translink-bus':
            return TranslinkPole;
        case 'translink-kerbside':
            return TranslinkKerbside;
        case 'translink-connection-train':
            return TranslinkCPT;
        case 'translink-connection-ferry':
            return TranslinkCPF;
        case 'translink_smbi':
            return TranslinkSMBI;
        case 'tfnsw_gen2':
            return TfnswNSD;
        case 'translink-stationlink':
            return TranslinkStationlink;
        case 'yarra-trams':
            return device.device_type == 'single' ? YarraTramsSingle : YarraTramsDouble;
        case 'philly':
            return PhiladelphiaParking;
        case 'bombah-ferry-16':
            return BombahPointFerry16km;
        case 'bombah-ferry-20':
            return BombahPointFerry20km;
        case 'transperth':
            return device.device_type == 'single' ? TransperthSingle : TransperthDouble;
        case 'ptv':
            return device.device_type == 'single' ? PTVSingle : PTVDouble;
        case 'dunedin':
            return Dunedin;
        case 'clearways':
            return ClearwaysSEC;
        case 'mbta-bus':
            return MBTABus;
        case 'mbta-tram':
            return MBTATram;
        case 'sopa-arc':
            return SOPAArcOfPines;
        case 'sopa-banquet':
            return SOPABanquet;
        case 'sopa-edu':
            return SOPAEducation;
        case 'sopa-egret':
            return SOPAEgret;
        case 'sopa-heron':
            return SOPAHeron;
        case 'sopa-hill':
            return SOPAHill;
        case 'sopa-lake':
            return SOPALakeside;
        case 'sopa-tree-frog':
            return SOPATreeFrog;
        case 'sopa-treillage':
            return SOPATreillage;
        case 'sopa-twin':
            return SOPATwinShade;
        case 'sopa-bell-frog':
            return SOPABellFrog;
        case 'sopa-corymbia':
            return SOPACorymbia;
        case 'dreamworld-mmr':
            return DreamworldMMR;
        case 'no_frame':
        default:
            return null;
    }
}

function setupLiveviewPerspective(url, deviceLayout, device, isPreview = false) {

    switch (device.overlay_id) {
        case 'translink-plinth':
            return [{
                url: url[0],
                zIndex: 1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.255, 0.165], // top left
                    [0.88, 0.17], // top right
                    [0.88, 0.675], // bottom right
                    [0.255, 0.69] // bottom left
                ]
            }];
        case 'translink-bus':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.382, 0.205], // top left
                    [0.755, 0.227], // top right
                    [0.755, 0.768], // bottom right
                    [0.382, 0.793] // bottom left
                ]
            }];
        case 'translink-kerbside':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.25,
                coords: [ // from top left
                    [0.42, 0.089], // top left
                    [0.863, 0.101], // top right
                    [0.863, 0.485], // bottom right
                    [0.42, 0.51] // bottom left
                ]
            }];
        case 'translink-connection-train':
        case 'translink-connection-ferry':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.5,
                coords: [ // from top left
                    [0.12, 0.38], // top left
                    [0.89, 0.4], // top right
                    [0.89, 0.725], // bottom right
                    [0.12, 0.752] // bottom left
                ]
            }];
        case 'translink_smbi':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.25,
                coords: [ // from top left
                    [0.143, 0.1], // top left
                    [0.9, 0.115], // top right
                    [0.905, 0.835], // bottom right
                    [0.148, 0.885] // bottom left
                ]
            }];
        case 'bombah-ferry-16':
        case 'bombah-ferry-20':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.2, 0.505], // top left
                    [0.8, 0.5], // top right
                    [0.8, 0.77], // bottom right
                    [0.2, 0.77] // bottom left
                ]
            }];
        case 'tfnsw_gen2':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.211, 0.134], // top left
                    [0.81, 0.156], // top right
                    [0.818, 0.77], // bottom right
                    [0.217, 0.777] // bottom left
                ]
            }];
        case 'translink-stationlink':
            return [{
                url: url[0],
                zIndex: 1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.09, 0.129], // top left
                    [0.875, 0.129], // top right
                    [0.875, 0.487], // bottom right
                    [0.09, 0.487] // bottom left
                ]
            },
            {
                url: url[1],
                zIndex: 1,
                dprBooster: 1.75,
                coords: [ // from top left
                    [0.09, 0.532], // top left
                    [0.875, 0.532], // top right
                    [0.875, 0.887], // bottom right
                    [0.09, 0.887] // bottom left
                ]
            }];
        case 'yarra-trams':
            if (device.device_type == 'single') {
                return [{
                    url: url[0],
                    zIndex: -1,
                    dprBooster: 1.4,
                    coords: [ // from top left
                        [0.28, 0.262], // top left
                        [0.82, 0.285], // top right
                        [0.82, 0.6], // bottom right
                        [0.28, 0.618] // bottom left
                    ]
                }];
            }
            else {
                return [{
                    url: url[0],
                    zIndex: -1,
                    dprBooster: 1.4,
                    coords: [ // from top left
                        [0.275, 0.197], // top left
                        [0.825, 0.217], // top right
                        [0.825, 0.709], // bottom right
                        [0.275, 0.731] // bottom left
                    ]
                }]
            }
        case 'ptv':
            if (device.device_type == 'single') {
                return [{
                    url: url[0],
                    zIndex: -1,
                    dprBooster: 1.4,
                    coords: [ // from top left
                        [0.28, 0.262], // top left
                        [0.82, 0.285], // top right
                        [0.82, 0.6], // bottom right
                        [0.28, 0.618] // bottom left
                    ]
                }];
            }
            else {
                return [{
                    url: url[0],
                    zIndex: -1,
                    dprBooster: 1.4,
                    coords: [ // from top left
                        [0.275, 0.197], // top left
                        [0.825, 0.217], // top right
                        [0.825, 0.709], // bottom right
                        [0.275, 0.731] // bottom left
                    ]
                }]
            }
        case 'dreamworld-mmr':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.25,
                coords: [ // from top left
                    [0.388, 0.638], // top left
                    [0.575, 0.64], // top right
                    [0.575, 0.755], // bottom right
                    [0.388, 0.75] // bottom left
                ]
            }];
        case 'clearways':
        case 'philly':
        case 'sopa-arc':
        case 'sopa-banquet':
        case 'sopa-edu':
        case 'sopa-egret':
        case 'sopa-heron':
        case 'sopa-hill':
        case 'sopa-lake':
        case 'sopa-tree-frog':
        case 'sopa-treillage':
        case 'sopa-twin':
        case 'sopa-bell-frog':
        case 'sopa-corymbia':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.25,
                coords: [ // from top left
                    [0.42, 0.089], // top left
                    [0.863, 0.101], // top right
                    [0.863, 0.485], // bottom right
                    [0.42, 0.51] // bottom left
                ]
            }];
        case 'transperth':
            if (device.device_type == 'double') {
                return (url?.[1] ? (
                    [{
                        url: url[0],
                        zIndex: 1,
                        dprBooster: 1.5,
                        coords: [ // from top left
                            [0.331, 0.2], // top left
                            [0.76, 0.2075], // top right
                            [0.76, 0.41], // bottom right
                            [0.331, 0.41] // bottom left
                        ]
                    },
                    {
                        url: url[1],
                        zIndex: 1,
                        dprBooster: 1.5,
                        coords: [ // from top left
                            [0.331, 0.41], // top left
                            [0.76, 0.41], // top right
                            [0.76, 0.619], // bottom right
                            [0.331, 0.625] // bottom left
                        ]
                    }]
                ) : (
                    [{
                        url: url[0],
                        zIndex: 1,
                        dprBooster: 1.5,
                        coords: [ // from top left
                            [0.331, 0.2], // top left
                            [0.76, 0.2075], // top right
                            [0.76, 0.619], // bottom right
                            [0.331, 0.625] // bottom left
                        ]
                    }]
                ));
            }
            else {
                return [{
                    url: url[0],
                    zIndex: 1,
                    dprBooster: 1.5,
                    coords: [ // from top left
                        [0.331, 0.3], // top left
                        [0.76, 0.306], // top right
                        [0.76, 0.51], // bottom right
                        [0.331, 0.516] // bottom left
                    ]
                }];
            }
        case 'dunedin':
            return [{
                url: url[0],
                zIndex: 1,
                dprBooster: 1.5,
                coords: [ // from top left
                    [0.255, 0.24], // top left
                    [0.78, 0.27], // top right
                    [0.78, 0.71], // bottom right
                    [0.255, 0.72] // bottom left
                ]
            }];
        case 'mbta-bus':
        case 'mbta-tram':
            return [{
                url: url[0],
                zIndex: -1,
                dprBooster: 1.5,
                coords: [ // from top left
                    [0.382, 0.205], // top left
                    [0.755, 0.227], // top right
                    [0.755, 0.768], // bottom right
                    [0.382, 0.793] // bottom left
                ]
            }]
        case 'no_frame':
        default:
            return (
                <>
                    <SoftBox
                        component="img"
                        src={url[0]}
                        position="absolute"
                        top="17%"
                        height="51%"
                        width="auto"
                        sx={{
                            transform: "translateX(12%) perspective(9cm) rotateY(7deg)",
                            transformOrigin: "left center",
                            zIndex: 2
                        }}
                    />
                    {url?.[1] && (
                        <SoftBox
                            component="img"
                            src={url[1]}
                            position="absolute"
                            top="57%"
                            height="51%"
                            width="auto"
                            sx={{
                                transform: "translateX(12%) perspective(9cm) rotateY(7deg)",
                                transformOrigin: "left center",
                                zIndex: 2
                            }}
                        />
                    )}
                </>
            );
    }
}

function LiveViewDisplay({ liveviews, device, deviceLayout, isPerspectiveLiveview, isPreview, minHeight }) {

    if (isPreview) {
        if (isPerspectiveLiveview) {
            return (
                <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ flexGrow: 1, flexShrink: 0, width: '100%', height: '100%', maxHeight: 'inherit' }}
                >
                    <SoftBox sx={{ position: 'relative', display: 'flex', justifyContent: "center", maxWidth: '100%', lineHeight: 0, maxHeight: 'inherit' }}>
                        {device.overlay_id == 'no_frame' ? (
                            setupLiveviewPerspective(liveviews.url, deviceLayout, device)
                        ) : (
                            <CombinedPerspectiveCanvas
                                base_image={setupLiveviewOverlay(device)}
                                source_images={setupLiveviewPerspective(liveviews.url, deviceLayout, device)}
                                minHeight={minHeight}
                            />
                        )}
                    </SoftBox>
                </SoftBox>
            );
        }
        else {
            return (
                <SoftBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ flexGrow: 1, width: '100%', height: '100%', overflowY: 'auto', maxHeight: 'inherit' }}
                >
                    {liveviews.url.map((url, index) => (
                        <SoftBox
                            key={index}
                            component="img"
                            src={url}
                            sx={{
                                minHeight: '100px',
                                maxWidth: "100%",
                                maxHeight: liveviews.url.length > 1 ? "48%" : "100%",
                                objectFit: "contain",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                            }}
                        />
                    ))}
                </SoftBox>
            );
        }
    }
    else {
        if (isPerspectiveLiveview) {
            return (
                <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ flexGrow: 1, width: '100%', height: '100%', overflowY: 'auto' }}
                >
                    <SoftBox sx={{ position: 'relative', display: 'block', height: '100%', maxHeight: '100%', lineHeight: 0, overflowX: 'hidden' }}>
                        {device.overlay_id == 'no_frame' ? (
                            setupLiveviewPerspective(liveviews.url, deviceLayout, device)
                        ) : (
                            <CombinedPerspectiveCanvas
                                base_image={setupLiveviewOverlay(device)}
                                source_images={setupLiveviewPerspective(liveviews.url, deviceLayout, device)}
                                minHeight={minHeight}
                            />
                        )}
                    </SoftBox>
                </SoftBox>
            );
        }
        else {
            return (
                <SoftBox
                    width="calc(100% - 16px)"
                    height="calc(100% - 16px)"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    pt={1}
                    px={1}
                    sx={{ overflow: 'auto', minHeight: '100px', maxHeight: 'calc(100svh - 13rem - 24px)' }}
                >
                    {liveviews.url.map((url, index) => (
                        <SoftBox
                            key={index}
                            component="img"
                            src={url}
                            sx={{
                                minHeight: '100px',
                                maxWidth: "100%",
                                maxHeight: liveviews.url.length > 1 ? "48%" : "100%",
                                objectFit: "contain",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                            }}
                        />
                    ))}
                </SoftBox>
            );
        }
    }
}

// Typechecking props for the LiveViewDisplay
LiveViewDisplay.propTypes = {
    device: PropTypes.object,
    liveviews: PropTypes.object,
    deviceLayout: PropTypes.string,
    isPerspectiveLiveview: PropTypes.bool,
    isPreview: PropTypes.bool,
    minHeight: PropTypes.string
};

export default LiveViewDisplay;